require('../proposals/array-find-from-last');
require('../proposals/array-grouping-stage-3-2');
require('../proposals/change-array-by-copy');
// TODO: Obsolete versions, remove from `core-js@4`
require('../proposals/array-grouping-stage-3');
var parent = require('./4');

module.exports = parent;
